import React, { Component } from 'react';
import { Dropdown } from '../components/elemans/_elemans';
import { Switch } from '../components/elemans/_elemans';
import { Login } from '../components/Login';
import { SaveDialog } from '../components/SaveDialog';
import Helper from '../services/Helper'
import { consts, icons } from '../services/_consts';
import { t, lang } from '../services/_lang';
import { cvFarsi, cvEng, myCv } from '../services/_templateData';
import CvMakerContext from '../services/app-context';


export  class MainToolbar extends Component {

    static contextType = CvMakerContext;

    style = {
        menu: {
            position: 'absolute',
            padding: '0px 0',
            background: 'white',
            borderRadius: '10px',
            border: '1px solid #c8c8c8',
            overflow: 'hidden',
            marginLeft: '-50px',
            marginTop: '6px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)'
        },
        las: {
            // background: 'gray',
            // padding: '3px',
            borderRadius: '5px',
            color: 'black',
            margin: '0 4px',
            fontSize: '24px'
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            contenteditableIsFocused: true,
            openUserMenu: false,
            menu1: false,
            openLoginModal: false,
            openSetting: false,
            loadingResume: false,
            myResumes: [],
            zoom: 100,
            template: 1,
            title: '',
            cv: cvEng
        };
    }

    componentDidMount() {
        window.addEventListener('click', this.onClickOutsideHandler);
        window.addEventListener("keydown", this.onKeyPressed);

        if (this.context.getCurrentUser()) {
            this.myResumesAsync();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onClickOutsideHandler);
        window.removeEventListener("keydown", this.onKeyPressed);
    }

    onKeyPressed = (e) => {
        if (e.ctrlKey && e.key === 's') {
            e.preventDefault();
            this.setState({ openSaveModal: true });
        }
    }

    onClickOutsideHandler = (event) => {
        if (this.state.menu1 && !this.toggleContainer.contains(event.target)) {
            this.setState({ menu1: false });
        }
        if (this.state.openUserMenu && this.userMenuContainer && !this.userMenuContainer.contains(event.target)) {
            this.setState({ openUserMenu: false });
        }
    }

    printCv = () => {
        //document.getElementById('toollbar').classList.add('d-none');
        window.print()
        //document.getElementById('toollbar').classList.remove('d-none');

        //var divContents = document.getElementById("GFG").innerHTML;
        //var head = document.getElementsByTagName('head')[0].innerHTML;
        //debugger;
        //var a = window.open('', '', 'height=500, width=500');
        //a.document.write('<html>');
        //a.document.write('<head>' + head + '<style></style>' + '</head>');
        //a.document.write('<body >');
        //a.document.write(divContents);
        //a.document.write('</body></html>');
        //a.document.close();
        //a.print();
    }

    saveCv = () => {
        let filename = this.state.cv.fullName + ".iResume";
        let text = Helper.encorypt({ cv: this.state.cv, template: this.state.template });


        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
        this.setState({ openLoginModal: false });
    }

    newCv = (cv) => {
        let t = this.state.template;
        this.setState({ template: 0 }, () => {
            this.setState({
                template: t,
                title: '',
                cv: cv
            });
        });
        //debugger
        document.title = 'iResume';
        this.newDropdown.close();
    }

    saveToServer = async (title) => {

        let text = Helper.encorypt({ cv: this.state.cv, template: this.state.template });

        const data = await Helper.callApiAsJson({
            url: 'resume/SaveResume', type: 'post',
            data: { resumeEnc: text, id: this.state.cv.id, title }
        })

        if (data && data.id) {
            this.setState({ openSaveModal: false, cv: { ...this.state.cv, id: data.id } });
            document.title = this.state.cv.fullName + '';
        }

        await this.myResumesAsync();
    }

    myResumesAsync = async () => {
        //const data = await Helper.callApiAsJson({
        //    url: 'resume/myResumes', type: 'get',
        //})
        const data = await fetch('resume/myResumes', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": 'bearer ' + localStorage.getItem('token')
            },
        })
            .then(data => {

                if (data.status == 401) {

                    this.context.signOut();
                }
                return data.json();
            })
            .catch((response) => { });
        if (data) {
            this.setState({ openLoginModal: false, myResumes: data });
        }
    }

    openResume = async (id) => {
        this.setState({
            openUserMenu: false,
            loadingResume: true
        });
        const data = await Helper.callApiAsJson({
            url: 'resume/Resume', type: 'post', data: { id }
        })

        if (data) {
            let resume = Helper.decode(data.text);

            this.setState({ template: 0 }, () => {

                this.setState({
                    openUserMenu: false,
                    loadingResume: false,
                    template: resume.template,
                    title: data.title,
                    cv: { ...resume.cv, id: id }
                });

                document.title = resume.cv.fullName + '';
            });
        }
    }

    removeResume = async (id) => {
        //if (! confirm("are you sure?")) return;

        const data = await Helper.callApiAsJson({
            url: 'resume/removeResume', type: 'post', data: { id }
        })

        if (data) {
            debugger;
            var myResumes = this.state.myResumes.filter(x => x.id != id);
            this.setState({ myResumes: myResumes })
        }
    }

    onFileSelecting = (evt) => {
        var files = evt.target.files;
        for (var i = 0, f; f = files[i]; i++) {
            var reader = new FileReader();
            reader.onload = ((theFile) => {
                return (e) => {
                    var content = e.target.result;
                    if (content) {
                        // Decrypt
                        var obj = Helper.decode(content);

                        this.setState({ template: 0 }, () => {
                            this.setState({ template: obj.template, cv: obj.cv });
                        });

                    }
                };
            })(f);

            reader.readAsText(f);
        }
    }

    addNewItem = (field) => {

        this.setState({ menu1: false });

        let oldLength = this.cvTemp.state[field].length;
        let obj = consts[field + "Temp"];
        this.cvTemp.setState({ [field]: [...this.cvTemp.state[field], obj] }, () => {
            let id = field + '' + (oldLength);
            this.scrollTo(id);
        });


    }


    signOut = () => {
        this.context.signOut();
        this.newCv(cvEng);
    }

    render() {
        return (
            <>
                <div id="toollbar" className={`${this.context.lang.rtl ? 'rtl aviny' : 'ltr'} noPrint ng-white navbar headcolor`}
                    style={{ direction: 'ltr', position: 'sticky', top: '-1px', zIndex: '3', padding: '3px 12px', borderBottom: '1px solid #cccbcb', backdropFilter: 'blur(6px)' }} >
                    <div className="selector1">
                        {this.state.cv && this.state.cv.id ? <button onClick={() => { window.open(`cv/${this.state.cv.id}/${this.state.cv.fullName.replace(" ", "-")}`, '_blank').focus(); }} className="btn btn-outline-dark btn-sm me-1 bg-white2 ">{this.context.lang.share} <i className="las la-share-alt-square"></i></button> : <></>}
                        <button onClick={() => { this.printCv() }} className="btn btn-outline-dark btn-sm me-1 bg-white2 "> <i className="las la-print"></i></button>
                        <Dropdown ref={e => this.newDropdown = e}
                            title={<><span className="d-none d-sm-inline">  {t("new")}</span> <i className="las la-file"></i></>}
                            className="btn btn-outline-dark btn-sm me-1 bg-white2 ">
                            <button onClick={() => this.newCv(cvEng)} className="btn btn-link text-start d-flex"><i className="las la-file float-start" style={this.style.las}></i>english_CV</button>
                            <button onClick={() => this.newCv(cvFarsi)} className="btn btn-link text-start d-flex"><i className="las la-file float-start" style={this.style.las}></i>رزومه_فارسی</button>
                        </Dropdown>
                        <button onClick={() => { this.setState({ openSaveModal: true }) }} className="btn btn-outline-dark btn-sm me-1 bg-white2 "><span className="d-none d-sm-inline">{t("save")}</span><i className="las la-save"></i></button>

                        <button onClick={() => document.getElementById('cvFile').click()} className="btn btn-outline-dark btn-sm me-1 bg-white2 "><span className="d-none d-sm-inline">{t("open")}</span><i className="las la-folder-open"></i></button>
                        <input onChange={(e) => { this.onFileSelecting(e) }} accept=".iResume" type="file" id="cvFile" className='d-none' />

                    </div>

                    {this.context.getCurrentUser() ?
                        <div className="user-btn" ref={e => this.userMenuContainer = e}>
                            <button onClick={() => this.setState({ openUserMenu: !this.state.openUserMenu })} className="btn btn-outline-dark btn-sm me-1 bg-white2 "><b>{this.context.getCurrentUser()?.userName}</b></button>
                            <div style={{ display: this.state.openUserMenu ? 'grid' : 'none', ...this.style.menu }}>
                                {this.state.myResumes.map((x, i) =>
                                    <div style={{ minWidth: '200px' }}>
                                        <button onClick={() => this.openResume(x.id)} key={i} className="btn btn-link text-start" style={{ width: '79%', maxWidth: '166px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                            <i className="lab la-wpforms" style={this.style.las}></i>{x.title}
                                        </button>
                                        <button
                                            onClick={() => this.removeResume(x.id)}
                                            className="btn btn-link text-danger float-end"><i class="las la-trash"></i></button>
                                    </div>
                                )}
                                <hr style={{ margin: '0.1rem 0' }} />
                                <button onClick={() => this.signOut()} className="btn btn-link text-start"><i className="las la-sign-out-alt" style={this.style.las}></i>Log out</button>
                            </div>
                        </div> :
                        <div className="user-btn">
                            <button onClick={() => { this.setState({ openLoginModal: true }) }} className="btn btn-outline-dark btn-sm me-1 bg-white2 ">{this.context.lang.login}<i className={icons.signIn}></i></button>
                        </div>
                    }

                    


                    <div><i></i></div>

                    <div className="d-inline-flex">
                        <div style={{ direction: this.context.lang == lang.farsi ? 'rtl' : 'ltr' }} className="lang-div">
                            <span className="d-none d-sm-inline">{t("lang")}</span>
                            <select value={this.context.lang._langName}
                                onChange={(e) => {
                                    this.context.toggleLanguage(e.target.value);
                                    let old = this.state.template
                                    this.setState({ template: 0 }, () => {
                                        this.setState({ template: old });
                                    });
                                }}
                                style={{ padding: '4px 8px', background: 'white', borderRadius: '5px' }} >
                                {['eng', 'فارسی'].map((x, i) => <option value={x} key={i} selected={this.context.lang._langName == x}>{x}</option>)}
                            </select>
                        </div>

                        <button onClick={() => { this.setState({ openSetting: !this.state.openSetting }) }} className="btn btn-outline-dark btn-sm ms-1 bg-white2 d-xl-none setting-div-btn"><span className="d-none d-sm-inline">{this.context.lang.setting}</span><i className={icons.cog}></i></button>

                    </div>

                </div>

                {this.state.openLoginModal &&
                    <Login title={this.state.title}
                        saveCv={this.saveCv}
                        saveToServer={this.saveToServer}
                        ocClose={() => this.setState({ openLoginModal: false })}
                        onAfterLogin={this.myResumesAsync} />
                }

                {this.state.openSaveModal &&
                    <SaveDialog title={this.state.title}
                        saveCv={this.saveCv}
                        saveToServer={this.saveToServer}
                        ocClose={() => this.setState({ openSaveModal: false })}
                        onAfterLogin={this.myResumesAsync} />
                }
            </ >
        );
    }
}
